<div *ngIf="formGroup"
     [formGroup]="formGroup">

  <div class="row no-gutters mb-input-margin-bottom">
    <div class="col-12 field-wrapper text-sm-left"
         mbFloatingLabel
         data-cy="mb-checkout-address-city">
      <label for="town"
             class="mandatory-input-asterisk mb-input-field-cursor mb-custom-label">{{ cityLabelKey | cxTranslate }}</label>
      <input class="w-100 mb-form-input"
             id="town"
             name="town"
             data-cy="mb-checkout-address-city-input"
             type="text"
             formControlName="town"
             required/>

      <mb-form-errors [control]="formGroup?.get(constants.TOWN_CODE)"
                      [prefix]="'formValidationErrors'">
      </mb-form-errors>
    </div>
  </div>

</div>
